var GatorSurvey = {};
GatorSurvey.app = {};
GatorSurvey.models = {};
GatorSurvey.directives = {};
GatorSurvey.models.isAuthenticated = false;
GatorSurvey.models.SelectedId = function() {
    var path = window.location.pathname.split("/");
    return path[path.length - 1];
};
GatorSurvey.models.SurveyId = function () {
    return GatorSurvey.models.SelectedId();
};
GatorSurvey.models.ApplicationSettings = {
    SsoUrl: null,
    UsingPixieImageEditor: true
};
GatorSurvey.models.checking = false;

GatorSurvey.models.guid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    var guidtemp = s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();

    str = guidtemp[0];
    patt1 = /([0-9])/g;
    result = str.match(patt1);
    if (result !== null) {
        guidtemp = "a" + guidtemp.slice(1, guidtemp.length);
    }
    return guidtemp;
};


String.prototype.toTitle = function () {
    return this.replace(/\w\S*/g, function(txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
};

String.prototype.contains = function (text, exactCase) {
    if (exactCase !== null)
    {
        if (exactCase) {
            return (this.indexOf(text) > -1);
        }
    }
    return (this.toLowerCase().indexOf(text.toLowerCase()) > -1);
};


Array.prototype.Merge = function (b_array) {
    if (Array.isArray(b_array)) {
        for (var i = 0; i < b_array.length; i++) {
            b_array[i] = this.push(b_array[i]);
        }
    }
    else {
        throw "input is not an Array";
    }
};

String.prototype.trimLeft = function (charlist) {
    if (charlist === undefined)
        charlist = "\s";

    return this.replace(new RegExp("^[" + charlist + "]+"), "");
};

String.prototype.trimRight = function (charlist) {
    if (charlist === undefined)
        charlist = "\s";

    return this.replace(new RegExp("[" + charlist + "]+$"), "");
};

